/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReservation200Response,
  CreateReservationRequest,
  GetConfig200Response,
  GetDayAvailability200ResponseValueInner,
  GetDayAvailabilityWithZoneId200ResponseValueInner,
  GetLocations200ResponseInner,
  GetReservation200Response,
  GetReservation404Response,
  GetReservation500Response,
  UpdateReservationRequest,
} from '../models/index';
import {
    CreateReservation200ResponseFromJSON,
    CreateReservation200ResponseToJSON,
    CreateReservationRequestFromJSON,
    CreateReservationRequestToJSON,
    GetConfig200ResponseFromJSON,
    GetConfig200ResponseToJSON,
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetDayAvailabilityWithZoneId200ResponseValueInnerFromJSON,
    GetDayAvailabilityWithZoneId200ResponseValueInnerToJSON,
    GetLocations200ResponseInnerFromJSON,
    GetLocations200ResponseInnerToJSON,
    GetReservation200ResponseFromJSON,
    GetReservation200ResponseToJSON,
    GetReservation404ResponseFromJSON,
    GetReservation404ResponseToJSON,
    GetReservation500ResponseFromJSON,
    GetReservation500ResponseToJSON,
    UpdateReservationRequestFromJSON,
    UpdateReservationRequestToJSON,
} from '../models/index';

export interface CancelReservationRequest {
    reservationId: string;
}

export interface CreateReservationOperationRequest {
    createReservationRequest: CreateReservationRequest;
}

export interface GetDayAvailabilityRequest {
    partySize: number;
    date: string;
    ignoreReservationId?: string;
    showAvailability?: boolean;
}

export interface GetDayAvailabilityWithZoneIdRequest {
    partySize: number;
    date: string;
    ignoreReservationId?: string;
    showAvailability?: boolean;
}

export interface GetMonthAvailabilityRequest {
    partySize: number;
    month: string;
    ignoreReservationId?: string;
}

export interface GetReservationRequest {
    reservationId: string;
}

export interface UpdateReservationOperationRequest {
    reservationId: string;
    updateReservationRequest: UpdateReservationRequest;
}

/**
 * 
 */
export class BookingsApi extends runtime.BaseAPI {

    /**
     */
    async cancelReservationRaw(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling cancelReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelReservation(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createReservationRaw(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateReservation200Response>> {
        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling createReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateReservation200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async createReservation(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateReservation200Response> {
        const response = await this.createReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConfig200Response> {
        const response = await this.getConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDayAvailabilityRaw(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getDayAvailability().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        if (requestParameters['showAvailability'] != null) {
            queryParameters['showAvailability'] = requestParameters['showAvailability'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDayAvailability(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }> {
        const response = await this.getDayAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDayAvailabilityWithZoneIdRaw(requestParameters: GetDayAvailabilityWithZoneIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetDayAvailabilityWithZoneId200ResponseValueInner>; }>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getDayAvailabilityWithZoneId().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayAvailabilityWithZoneId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        if (requestParameters['showAvailability'] != null) {
            queryParameters['showAvailability'] = requestParameters['showAvailability'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/day/v2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDayAvailabilityWithZoneId(requestParameters: GetDayAvailabilityWithZoneIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetDayAvailabilityWithZoneId200ResponseValueInner>; }> {
        const response = await this.getDayAvailabilityWithZoneIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLocations200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLocations200ResponseInnerFromJSON));
    }

    /**
     */
    async getLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLocations200ResponseInner>> {
        const response = await this.getLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMonthAvailabilityRaw(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getMonthAvailability().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling getMonthAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/availability/month`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMonthAvailability(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMonthAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationRaw(requestParameters: GetReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservation200Response>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling getReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservation200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservation(requestParameters: GetReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservation200Response> {
        const response = await this.getReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateReservationRaw(requestParameters: UpdateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservation().'
            );
        }

        if (requestParameters['updateReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReservationRequest',
                'Required parameter "updateReservationRequest" was null or undefined when calling updateReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReservationRequestToJSON(requestParameters['updateReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservation(requestParameters: UpdateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationRaw(requestParameters, initOverrides);
    }

}
